import { Link } from 'react-router-dom';
import { MessageCircle, Mail, MapPin, Clock } from 'lucide-react';
import { BrandLogo } from '@/components/common/BrandLogo';
import { footerNavigation } from '@/data/navigation';
import { siteConfig } from '@/data/site';
import { legalNotices } from '@/data/legal';
import { buildGeneralWhatsAppMessage, buildWhatsAppUrl } from '@/utils';

export function Footer() {
  const year = new Date().getFullYear();
  const whatsappUrl = siteConfig.contact.whatsapp
    ? buildWhatsAppUrl(siteConfig.contact.whatsapp, buildGeneralWhatsAppMessage())
    : undefined;

  return (
    <footer className="bg-charcoal text-semantic-text-on-dark" role="contentinfo">
      <div className="container-content section-padding pb-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <BrandLogo variant="light" />
            <p className="mt-4 text-sm leading-relaxed text-semantic-text-on-dark/70">
              {siteConfig.descriptor}
            </p>
            <p className="mt-3 text-xs text-semantic-text-on-dark/50">
              Vinculados institucionalmente a {siteConfig.legalPartner.name}.
            </p>
          </div>

          <div>
            <h2 className="mb-4 font-heading text-lg font-semibold text-gold-light">Propiedades</h2>
            <ul className="space-y-2">
              {footerNavigation.properties.map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-sm text-semantic-text-on-dark/70 hover:text-gold-light">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="mb-4 font-heading text-lg font-semibold text-gold-light">Servicios</h2>
            <ul className="space-y-2">
              {footerNavigation.services.map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-sm text-semantic-text-on-dark/70 hover:text-gold-light">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="mb-4 font-heading text-lg font-semibold text-gold-light">Contacto</h2>
            <ul className="space-y-3 text-sm text-semantic-text-on-dark/70">
              {siteConfig.contact.email ? (
                <li className="flex items-center gap-2">
                  <Mail className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                  <a href={`mailto:${siteConfig.contact.email}`} className="hover:text-gold-light">
                    {siteConfig.contact.email}
                  </a>
                </li>
              ) : (
                <li className="text-xs italic">TODO: CONFIRMAR INFORMACIÓN — Correo</li>
              )}
              {whatsappUrl ? (
                <li className="flex items-center gap-2">
                  <MessageCircle className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                  <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="hover:text-gold-light">
                    WhatsApp
                  </a>
                </li>
              ) : (
                <li className="text-xs italic">TODO: CONFIRMAR INFORMACIÓN — WhatsApp</li>
              )}
              {siteConfig.contact.address ? (
                <li className="flex items-start gap-2">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                  <span>{siteConfig.contact.address}</span>
                </li>
              ) : null}
              {siteConfig.contact.schedule ? (
                <li className="flex items-center gap-2">
                  <Clock className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                  <span>{siteConfig.contact.schedule}</span>
                </li>
              ) : null}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-8">
          <p className="mb-4 text-xs leading-relaxed text-semantic-text-on-dark/50">
            {legalNotices.priceAvailabilityFooter}
          </p>
          <p className="mb-4 text-xs leading-relaxed text-semantic-text-on-dark/50">
            {legalNotices.serviceDifferentiation}
          </p>
          <div className="flex flex-wrap items-center justify-between gap-4">
            <p className="text-xs text-semantic-text-on-dark/50">
              © {year} {siteConfig.name}. Todos los derechos reservados.
            </p>
            <ul className="flex flex-wrap gap-4">
              {footerNavigation.legal.map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-xs text-semantic-text-on-dark/50 hover:text-gold-light">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
